"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExpandoWidget = exports.ExpandoDirection = void 0;
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var TypeStyle = tslib_1.__importStar(require("typestyle"));
var Icons_1 = require("../icons/Icons");
var FocusIndicators_1 = require("../styles/FocusIndicators");
var PreventUserSelect_1 = require("../styles/PreventUserSelect");
var TabStyles_1 = require("../styles/TabStyles");
var Animation_1 = require("../utils/Animation");
var Declarative_1 = require("../utils/Declarative");
var DomUtil_1 = require("../utils/DomUtil");
var HeightAnimator_1 = require("../utils/HeightAnimator");
var InteractiveDom_1 = require("../utils/InteractiveDom");
var ReactHelpers_1 = require("../utils/ReactHelpers");
var DomWidgets_1 = require("./DomWidgets");
var Spacing = TabStyles_1.TabStyles.Spacing;
var ExpandoDirection;
(function (ExpandoDirection) {
    ExpandoDirection[ExpandoDirection["Up"] = 0] = "Up";
    ExpandoDirection[ExpandoDirection["Down"] = 1] = "Down";
})(ExpandoDirection = exports.ExpandoDirection || (exports.ExpandoDirection = {}));
var ExpandoButtonStyleName = TypeStyle.style(tslib_1.__assign(tslib_1.__assign({}, PreventUserSelect_1.PreventUserSelect), { alignItems: 'center', cursor: 'pointer', display: 'flex' }));
var ExpandoRightButtonStyleName = TypeStyle.style({
    flexDirection: 'row-reverse',
    justifyContent: 'space-between',
});
// In the collapsed state, caret either points right or left
var CollapsedIconTransform = Object.freeze({
    left: 'rotate(90deg)',
    right: 'rotate(-90deg)',
});
// In the expanded state, caret either points up or down
var ExpandedIconTransform = Object.freeze((_a = {},
    _a[ExpandoDirection.Up + "left"] = 'rotate(0deg)',
    _a[ExpandoDirection.Up + "right"] = 'rotate(0deg)',
    _a[ExpandoDirection.Down + "left"] = 'rotate(180deg)',
    _a[ExpandoDirection.Down + "right"] = 'rotate(-180deg)',
    _a));
/**
 * **NOTE**: all HTML props are applied to the focusable button element, with the exception of `style` and `className`, which are applied
 * to the root wrapper element.
 */
var ExpandoWidget = /** @class */ (function (_super) {
    tslib_1.__extends(ExpandoWidget, _super);
    function ExpandoWidget() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.expandoBaseTestId = 'Expando';
        _this.contentId = DomUtil_1.generateId();
        _this.state = {
            hoveringOnExpandoButton: false,
        };
        _this.handleClick = function (e) {
            _this.handleExpandOrCollapse();
        };
        _this.handleKey = function (e) {
            if (e.key === ' ' || e.key === 'Enter') {
                e.stopPropagation();
                e.preventDefault();
                if (e.type === 'keyup') {
                    _this.handleExpandOrCollapse();
                }
            }
        };
        _this.handleKeyDown = ReactHelpers_1.mergeEventHandlers(_this.handleKey, function (e) { var _a, _b; return (_b = (_a = _this.props).onKeyDown) === null || _b === void 0 ? void 0 : _b.call(_a, e); });
        _this.handleKeyUp = ReactHelpers_1.mergeEventHandlers(_this.handleKey, function (e) { var _a, _b; return (_b = (_a = _this.props).onKeyUp) === null || _b === void 0 ? void 0 : _b.call(_a, e); });
        _this.handleHover = function (hover) {
            _this.setState({ hoveringOnExpandoButton: hover });
        };
        return _this;
    }
    ExpandoWidget.prototype.handleExpandOrCollapse = function () {
        if (this.props.isExpanded) {
            this.props.onCollapse();
        }
        else {
            this.props.onExpand();
        }
    };
    ExpandoWidget.prototype.getExpandoStyle = function () {
        return {
            display: 'flex',
            flexDirection: this.props.direction === ExpandoDirection.Up ? 'column-reverse' : 'column',
            alignItems: this.props.alignment === 'right' ? 'stretch' : 'flex-start',
        };
    };
    ExpandoWidget.prototype.getExpandoIconStyle = function () {
        return {
            height: Icons_1.ExpandoIcon.height,
            margin: 'auto',
            marginLeft: 0,
            marginRight: this.props.label ? Spacing.DefaultSpace : 0,
            transform: this.props.isExpanded ?
                ExpandedIconTransform[this.props.direction + this.props.alignment] :
                // collapsed state only cares about alignment, not direction
                CollapsedIconTransform[this.props.alignment],
            transition: "transform, " + Animation_1.AnimationDuration + "ms",
            width: Icons_1.ExpandoIcon.width,
        };
    };
    ExpandoWidget.prototype.render = function () {
        // tslint:disable-next-line: deprecation
        var _a = this.props, alignment = _a.alignment, children = _a.children, className = _a.className, direction = _a.direction, isExpanded = _a.isExpanded, label = _a.label, keepChildrenMounted = _a.keepChildrenMounted, onCollapse = _a.onCollapse, onExpand = _a.onExpand, style = _a.style, testId = _a.testId, htmlAttrs = tslib_1.__rest(_a, ["alignment", "children", "className", "direction", "isExpanded", "label", "keepChildrenMounted", "onCollapse", "onExpand", "style", "testId"]);
        var contentHeight = isExpanded ? 'auto' : 0;
        return (React.createElement("div", { className: className, "data-tb-test-id": Declarative_1.makeTestId(testId, this.expandoBaseTestId), style: tslib_1.__assign(tslib_1.__assign({}, this.getExpandoStyle()), style) },
            React.createElement(InteractiveDom_1.InteractiveDomWrapper, { key: 'expandoInteractiveDom', handleHover: this.handleHover, pointerClick: this.handleClick },
                React.createElement("div", tslib_1.__assign({}, htmlAttrs, (isExpanded && { 'aria-controls': this.contentId }), { "aria-expanded": isExpanded, className: TypeStyle.classes(ExpandoButtonStyleName, FocusIndicators_1.FocusVisibleIndicator, alignment === 'right' && ExpandoRightButtonStyleName), "data-tb-test-id": Declarative_1.makeTestId(testId, this.expandoBaseTestId, 'Button'), onKeyDown: this.handleKeyDown, onKeyUp: this.handleKeyUp, role: 'button', tabIndex: 0 }),
                    React.createElement(DomWidgets_1.Img, { key: 'expandoIcon', "data-tb-test-id": Declarative_1.makeTestId(testId, this.expandoBaseTestId, 'Icon'), src: Icons_1.ExpandoIcon.icon({ active: this.state.hoveringOnExpandoButton }), style: this.getExpandoIconStyle() }),
                    label &&
                        React.createElement("div", { key: 'expandoLabel', "data-tb-test-id": Declarative_1.makeTestId(testId, this.expandoBaseTestId, 'Label') }, label))),
            React.createElement(HeightAnimator_1.HeightAnimator, tslib_1.__assign({}, (keepChildrenMounted && { height: contentHeight }), { initialHeight: contentHeight }), (keepChildrenMounted || isExpanded) && React.createElement("div", { key: 'expandoContent', "data-tb-test-id": Declarative_1.makeTestId(testId, this.expandoBaseTestId, 'Content'), id: this.contentId }, children))));
    };
    ExpandoWidget.defaultProps = {
        direction: ExpandoDirection.Down,
        alignment: 'left',
    };
    return ExpandoWidget;
}(React.Component));
exports.ExpandoWidget = ExpandoWidget;
//# sourceMappingURL=ExpandoWidget.js.map